import styled, { css } from 'styled-components';

// Types
import { TypeMaxLength } from './types';

type InputContainerProps = {
  disabled: boolean | undefined;
  maxLength: TypeMaxLength;
};

export const InputContainer = styled.div<InputContainerProps>`
  &:nth-of-type(2) input {
    width: calc(2.2rem + 7ch);
  }
  &:nth-of-type(3) input {
    width: calc(2.2rem + 4ch);
  }
`;

export const InputValue = styled.input`
  padding: 0 1rem;
  height: 4rem;
  width: calc(2.2rem + 2ch);
  border-radius: 0.5rem;
  font-size: ${({ theme }) => theme.fontSize.S};
  border: ${(props) =>
    !props.disabled ? `0.1rem solid ${props.theme.colors.black}` : 'none'};
  ${(props) =>
    !props.disabled &&
    css`
      background-color: ${props.theme.colors.white};
    `}

  ${(props) =>
    props.disabled &&
    css`
      background-color: ${props.theme.colors.greyLight};
    `}

  &:focus {
    outline: 0.08rem solid ${({ theme }) => theme.colors.black};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.greySoftLight};
    opacity: 1;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;
